import { render, staticRenderFns } from "./DoctorAsissAcounting.vue?vue&type=template&id=1fb00066&scoped=true"
import script from "./DoctorAsissAcounting.vue?vue&type=script&lang=js"
export * from "./DoctorAsissAcounting.vue?vue&type=script&lang=js"
import style0 from "./DoctorAsissAcounting.vue?vue&type=style&index=0&id=1fb00066&prod&scoped=true&lang=css"
import style1 from "./DoctorAsissAcounting.vue?vue&type=style&index=1&id=1fb00066&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb00066",
  null
  
)

export default component.exports